import React, { Component } from 'react';
// components
import {Radio, Select} from 'components/inputs';
import { Row, Col, Input, Button } from 'reactstrap';
import { findOption } from 'functions/selects';
import { FontAwesome, NumberDisplay } from 'components/ui';

export class PlatoonRow extends Component {

  render() {
    const { inputProps, onSelectChange, onDelete, isCamp } = this.props;
    const {
      class_grade, class_sub, class_teacher, cell, email,
      soldiers, miles_per_soldier, miles_balance, updated
    } = this.props.platoon;

    const grades = isCamp
      ? Array.from({ length: 40 }, (_, i) => ({ label: String(i + 1), value: String(i + 1) }))
      : [ 'Pre1a', '1', '2', '3', '4', '5', '6', '7', '8' ].map( grade =>
          grade === 'Pre1a' ? { label: 'Pre1a / Kindergarten', value: grade } : { label: grade, value: grade }
        );
    const selectedGrade = findOption( grades, class_grade );

    return (
      <Row>
        <Col sm={6}>
          <label>{ isCamp ? 'Bunk' : 'Grade' }</label>
          <Select
            required
            options={ grades }
            value={ selectedGrade }
            onChange={ onSelectChange('class_grade') } />
        </Col>

        <Col sm={6}>
          <label>{ isCamp ? 'Bunk Name' : "Class (e.g. 'Boys' or 'א‬'.)" }</label>
          <Input name='class_sub' value={ class_sub || '' } { ...inputProps } required={ false }/>
        </Col>

        { !isCamp && <Col sm={12}>
          <label>Teacher Name</label>
          <Input name='class_teacher' value={ class_teacher || '' } { ...inputProps } />
        </Col> }

        { !isCamp && <Col sm={6}>
          <label>Teacher Phone</label>
          <Input name='cell' type='tel' value={ cell || '' }
            { ...inputProps } title='separate multiple email addresses with a comma' />
          <div className='invalid-message'>separate multiple email addresses with a comma</div>
        </Col> }

        { !isCamp && <Col sm={6}>
          <label>Teacher E-Mail</label>
          <Input name='email' value={ email || '' } { ...inputProps }
            title='1 or more valid E-mail addresses (, or ; seperated)'
            pattern='^(\s?[^\s,]+@[^\s,]+\.[^\s,]+\s?[,;])*(\s?[^\s,]+@[^\s,]+\.[^\s,]+)$' />
          <div className='invalid-message'>1 or more valid E-mail addresses (, or ; seperated)</div>
        </Col> }

        { !isCamp && <Col sm={6}>
          <Radio name='updated' value='1' checked={updated === '1' || updated === 1} {...inputProps} />
          <label>Updated</label>
          <Radio name='updated' value='0' checked={updated === '0' || updated === 0} {...inputProps} />
          <label>Not Updated</label>
        </Col> }

        { soldiers && soldiers.length === 0 &&
          <Col sm={12}>
            <Button color='danger' onClick={ onDelete } id='delete'>
              <FontAwesome icon='trash' /> { isCamp ? 'Delete Bunk' : 'Delete Platoon' }
            </Button>
          </Col>
        }

        { !isCamp && <Col xs={12}><p className='title'>Achievement Card Settings</p></Col> }

        { !isCamp && <Col sm={6}>
          <label>Miles per Soldier (per month)</label>
          <Input type='number' name='miles_per_soldier' value={ miles_per_soldier } { ...inputProps } />
        </Col> }

        { !isCamp && <Col sm={6}>
          <label>Current Miles Balance</label>
          <Input type='number' name='miles_balance' min='0' max='99999999999'
            value={ miles_balance } { ...inputProps } />
          <div className='invalid-message'>0 to <NumberDisplay value={ 99999999999 } /></div>
        </Col> }

      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/base-managment/platoons/tabs/PlatoonRow.jsx